import { Mail } from 'assets'
import CustomButton from 'components/CustomButton'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Input, InputGroup, InputGroupText, Label } from 'reactstrap'

const CustomInput = (props) => {
  const {
    label,
    placeholder,
    onChange,
    name,
    value,
    Icon,
    type,
    iconPosition,
    secondLabel = null,
    secondLabelStyle = null,
    iconAction = null,
    error,
    className,
    disabled,
    required,
    hasButton = null,
    buttonAction = null,
    errorArr = null,
    errorBorder = false,
    ref,
    onClick,
    otherButtonLabel = "Add"
  } = props

  const navigate = useNavigate()

  const leftStyle = {
    icon: {
      left: "16px",
      display: `${name === 'email' ? value ? 'none' : 'inline-block' : 'inline-block'}`
    },
    input: {
      padding: `${name === "email" ? value ? "16px 16px 16px 16px" : "16px 16px 16px 46px" : "16px 16px 16px 46px"}`,
      border: `${error ? "1px solid var(--danger-border)" : "1px solid var(--border)"}`
    }
  }

  const rightStyle = {
    icon: {
      right: "16px",
      cursor: "pointer"
    },
    input: {
      padding: "16px 46px 16px 16px",
      border: `${error ? "1px solid var(--danger-border)" : "1px solid var(--border)"}`
    }
  }

  const noIconStyle = {
    border: `${error ? "1px solid var(--danger-border)" : "1px solid var(--border)"}`
  }

  const lupaPassword = () => {
    navigate("/auth/lupa-password")
  }

  return (
    <div className='input-wrapper'>
      {label && (
        <div className='d-flex justify-content-between'>
          <Label>{required && <span style={{ color: 'var(--danger)' }}>* </span>}{label}</Label>
          {secondLabel && <Label style={secondLabelStyle} onClick={lupaPassword}>{secondLabel}</Label>}
        </div>
      )}
      <InputGroup style={{ flexWrap: 'unset', borderTopLeftRadius: "0.375 rem !important" }} ref={ref}>
        <input
          className={className ? className : `custom-input ${hasButton ? 'd-flex flex-row' : errorBorder ? 'error-border' : ""}`}
          onChange={onChange}
          name={name}
          type={type}
          value={value}
          placeholder={placeholder}
          style={iconPosition ? iconPosition === "left" ? leftStyle.input : rightStyle.input : noIconStyle}
          disabled={disabled}
          onClick={onClick}
          ref={ref}
        />
        {hasButton && <CustomButton onClick={buttonAction} className="ms-1 flex-grow-1 px-4" color="primary-btn" label={otherButtonLabel} />}
        {Icon &&
          <Icon
            className="input-icon"
            onClick={iconAction}
            style={iconPosition ? iconPosition === "left" ? leftStyle.icon : rightStyle.icon : null}
          />
        }
      </InputGroup>
      {error && <span className='error-input'>{error}</span>}
      {errorArr && errorArr.map((data) => <span className='error-input'>{data.msg || data}</span>)}
    </div>
  )
}

export default CustomInput